import type { FaireProductEntity } from "../../entity_types/product";

export const p_5przga7jc8: FaireProductEntity = {
  token: "p_5przga7jc8",
  type: "product",
  name: "Bear Face Stripe & Collar Knit Jumpsuit (Organic Cotton)",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/77f77d90c8a70b0764b9eec510684ff91625c0b61b4258d6823c8eac49af3611.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8d20c1458e01371148f5cf5b7d59bc652b03646f0a381182d5b027f9436e8dde.jpeg",
    "https://cdn.faire.com/fastly/9116edc0e8af429959f051f8dc62ef2da9b7500cfe289ffb3f13b6a472e36c10.jpeg",
  ],
  priceDollars: 26,
  description:
    "This striped knit baby jumpsuit has a charcoal base with soft natural stripes for a gentle, cozy look. Finished with a classic button-front design and cute bear applique, it’s a charming one-piece made for everyday comfort and special moments alike.\n\nOur 100% organic cotton baby sweater is thoughtfully made as a truly special piece, blending timeless beauty, comfort, and sustainability. Designed for families who value thoughtfully made organic baby clothes, it reflects heirloom-quality craftsmanship and refined design.\n\n𝐖𝐡𝐲 𝐈𝐭’𝐬 𝐒𝐩𝐞𝐜𝐢𝐚𝐥:\n\n• Heirloom-Quality Organic Cotton: Breathable, GOTS-certified organic cotton with exceptional softness and a beautiful finish.\n\n• Safe, Non-Toxic & Gentle: Eco-friendly, chemical-free materials and gentle dyes for delicate skin.\n\n• Crafted to Last: Meticulous detailing ensures lasting quality and comfort.\n\n• Designed in the USA, Responsibly Made: Designed in the USA and ethically produced in India, supporting sustainable practices.\n\n• Timeless Design: Whimsical yet refined details for everyday moments and special occasions.\n\n𝐏𝐞𝐫𝐟𝐞𝐜𝐭 𝐟𝐨𝐫 𝐆𝐢𝐟𝐭𝐢𝐧𝐠:\nWith its heirloom-quality feel and timeless design, this organic cotton baby sweater makes a meaningful gift for baby showers, newborns, and first holidays.\n\nChoose Viverano Organics for heirloom-quality organic baby clothing—thoughtfully designed for little ones and the planet. Happy baby. Happy earth.",
  tags: [],
  msrpDollars: 52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T18:02:34.395Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
